import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IContactInfo } from '../../models/home/contacts';
import { environment } from '@env/environment';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({
  providedIn: 'root',
})

export class ContactsService {
  private api: string = environment.privateApi + 'MainMenu/';

  // Mat-table settings
  expandedElement: IContactInfo | null;

  constructor(private http: HttpClient){}

  getContactInfo(): Observable<IContactInfo> {
    return this.http.get<IContactInfo>(this.api + "contact", httpOptions);
  }

}
